module.exports = __webpack_public_path__ + "static/media/speakers.1593fe6b.svg";